import React from "react";
import { Square } from "./Square";
function InnerBoard(props) {
    return (React.createElement(React.Fragment, null, props.metaMatrix.allRows().map(function (row, i) {
        return (React.createElement("div", { key: i, className: "board-row" }, row.map(function (location) {
            return (React.createElement(Square, { key: location.index, location: location, onSquareMouseEnter: props.onSquareMouseEnter, onSquareMouseLeave: props.onSquareMouseLeave }));
        })));
    })));
}
var MemoInnerBoard = React.memo(InnerBoard);
/**
 * A game board made up of squares.
 */
export function GameBoard(props) {
    return (React.createElement("div", { className: "game-board", onMouseUp: props.onBoardMouseUp, onMouseDown: props.onBoardMouseDown, onMouseLeave: props.onBoardMouseLeave },
        React.createElement(MemoInnerBoard, { metaMatrix: props.metaMatrix, onSquareMouseEnter: props.onSquareMouseEnter, onSquareMouseLeave: props.onSquareMouseLeave })));
}
